module.exports = __webpack_public_path__ + "kai-in-a-spaceship-277x173.png?24f68d792d22676cf48411143b041cd0";